import { jsx, css } from '@emotion/react';
import { Icon } from '../../display/Icon/Icon.es.js';

const Styles = {
  root: (marginLeft, marginRight) => css({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginLeft,
    marginRight
  })
};
const InteractiveTagIcon = ({ ariaHidden = true, ariaLabel, name, position }) => {
  const calculateLeftMargin = () => {
    if (name === "formX") {
      return position === "before" ? "-5px" : "0px";
    }
    return "0px";
  };
  const calculateRightMargin = () => {
    if (name === "formX") {
      return position === "after" ? "-5px" : "0px";
    }
    return "0px";
  };
  return jsx(
    "div",
    { css: Styles.root(calculateLeftMargin(), calculateRightMargin()), "data-zds": true },
    jsx(Icon, { ariaHidden, ariaLabel, name, size: 24 })
  );
};

export { InteractiveTagIcon };
//# sourceMappingURL=InteractiveTagIcon.es.js.map
